import { useState, useEffect } from "react";

export const calculateTimeRemaining = (
  lastActiveTimestamp, //in seconds
  sessionLength, //in seconds
  getNow = () => Math.floor(Date.now() / 1000) // in seconds for testing
) => {
  if (
    typeof lastActiveTimestamp !== "number" ||
    typeof sessionLength !== "number" ||
    lastActiveTimestamp <= 0 ||
    sessionLength <= 0
  ) {
    return null;
  }
  const endTime = lastActiveTimestamp + sessionLength;
  let now = getNow();
  let timeRemaining = {};
  const difference = +endTime - +now;

  if (difference > 0) {
    timeRemaining = {
      days: Math.floor(difference / (60 * 60 * 24)),
      hours: Math.floor((difference / (60 * 60)) % 24),
      minutes: Math.floor((difference / 60) % 60),
      seconds: Math.floor(difference % 60),
    };
  } else {
    timeRemaining = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
  return timeRemaining;
};

const CountdownTimer = ({
  lastActiveTimestamp, //in seconds
  sessionLength = 2 * 60 * 60, //in seconds
}) => {
  const defaultTime = {
    days: Math.floor(+sessionLength / (60 * 60 * 24)),
    hours: Math.floor((+sessionLength / (60 * 60)) % 24),
    minutes: Math.floor((+sessionLength / 60) % 60),
    seconds: Math.floor(+sessionLength % 60),
  };
  const [timeRemaining, setTimeRemaining] = useState(defaultTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(
        calculateTimeRemaining(lastActiveTimestamp, +sessionLength)
      );
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [lastActiveTimestamp, sessionLength]);

  let seconds = timeRemaining?.seconds
    ? ("0" + Math.floor(timeRemaining.seconds)).slice(-2)
    : "00";
  let minutes = timeRemaining?.minutes
    ? ("0" + Math.floor(timeRemaining.minutes)).slice(-2)
    : "00";
  let hours = timeRemaining?.hours
    ? ("0" + Math.floor(timeRemaining.hours)).slice(-2)
    : "00";
  let days = timeRemaining?.days
    ? ("0" + Math.floor(timeRemaining.days)).slice(-3)
    : "00";

  const timerStyle = {
    color: days <= 0 && hours <= 0 && minutes < 5 ? "red" : "",
    fontWeight: days <= 0 && hours <= 0 && minutes < 5 ? "bold" : "",
    fontSize: days <= 0 && hours <= 0 && minutes < 5 ? "1rem" : "",
    flex: 1,
    textAlign: "end",
  };

  return (
    <div data-testid="countdown-timer" style={timerStyle}>
      Session Timeout:{" "}
      {days > 0
        ? `${days}:${hours}:${minutes}:${seconds}`
        : `${hours}:${minutes}:${seconds}`}
    </div>
  );
};

export default CountdownTimer;
